import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { APIErrorResponse, PostQuotationResearchCoupleRounds } from '@/types'
import { getUseQuotationDetailsKey } from './useQuotationDetails'

export const usePostQuotationResearchCoupleRounds = (
  quotationId: number,
  researchId: number
): UseMutationResult<
  unknown,
  APIErrorResponse,
  PostQuotationResearchCoupleRounds
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  const quotationDetailsKey = getUseQuotationDetailsKey(quotationId)

  return useMutation(
    (params) =>
      client
        .post(
          `/quotations/${quotationId}/researches/${researchId}/rounds/couple_rounds/`,
          params
        )
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(quotationDetailsKey)
      },
    }
  )
}
